import React, { useEffect } from "react";
import VslHero from "./VslHero";
import HeroVideoBg from "./HeroVideoBg";
import WistiaPlayer from "./WistiaPlayer";
import Contabili from "./Contabili";
import Products from "./Products";
import VslFooter from "./VslFooter";
import FloatingLiveCta from "./FloatingLiveCta";
import ScrollCue from "./ScrollCue";

// Sezioni della landing (stesso stile già presente)
import Recognition from "../Recognition";
import SkillLadder from "../SkillLadder";
import LessonPoints from "../LessonPoints";
import Phases from "../Phases";
import Mentor from "../Mentor";
import Testimonials from "../Testimonials";
import ForWhom from "../ForWhom";
import LiveSession from "../LiveSession";
import Application from "../Application";
import Faq from "../Faq";

// Pagina principale VSL nello stile reale di highticketsales.it
export default function VslPage() {
  useEffect(() => {
    document.documentElement.classList.add("vsl-root");
    const id = window.location.hash.slice(1);
    if (id) setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" }), 300);
    return () => document.documentElement.classList.remove("vsl-root");
  }, []);

  return (
    <div className="v-page">
      <div data-testid="hero-wrapper" className="relative overflow-hidden">
        <HeroVideoBg />
        <div className="relative" style={{ zIndex: 1 }}>
          <header className="flex justify-center pt-4 pb-1">
            <img src="/logo-hts.png" alt="HighTicketSales.it" style={{ height: 29, width: "auto" }} />
          </header>
          <VslHero />
        </div>
      </div>

      <main>
        <WistiaPlayer />
        <ScrollCue />

        {/* Sezioni aggiunte: dopo il player e prima di Contabili */}
        <Recognition />
        <SkillLadder />
        <LessonPoints />
        <Phases />
        <Mentor />
        <Contabili />
        <Testimonials />
        <ForWhom />
        <LiveSession />
        <Application />
        <Faq />

        <Products />
      </main>

      <VslFooter />
      <div className="h-20 sm:h-0" aria-hidden />
      <FloatingLiveCta />
    </div>
  );
}
